import $ from 'jquery';

export default function calendarMsFilter() {

  function init() {
    function applyFilter(filter, label) {
      $('.calendar-ms-filter__item').removeClass('calendar-ms-filter__item--active');
      $('.calendar-ms-filter__link[data-filter="'+filter+'"]')
        .parent('.calendar-ms-filter__item')
        .addClass('calendar-ms-filter__item--active');

      if (filter === 'all') {
        $('.calendar-ms-list__list .intranet-card-calendar-ms').show();
      } else {
        $('.calendar-ms-list__list .intranet-card-calendar-ms').hide();
        $('.calendar-ms-list__list').find('div[data-group="'+filter+'"]').show();
      }

      let $list = $('.calendar-ms-list__list');
      let template = $list.data('no-results');
      let templateAll = $list.data('no-results-all');
      let message = '';

      if (filter === 'all') {
        message = templateAll || '';
      } else {
        message = template ? template.replace('{0}', label) : '';
      }

      // controllo risultati
      if ($('.calendar-ms-list__list .intranet-card-calendar-ms:visible').length === 0) {
        if ($('.calendar-ms-list__no-results').length === 0) {
          $list.append('<div class="calendar-ms-list__no-results">' + message + '</div>');
        } else {
          $('.calendar-ms-list__no-results').text(message);
        }
      } else {
        $('.calendar-ms-list__no-results').remove();
      }
    }

    $('.calendar-ms-filter').on('click', '.calendar-ms-filter__link', function () {
      let filter = $(this).data('filter');
      let label = $(this).text().trim();

      applyFilter(filter, label);
    });
  }

  $( document ).ready(function() {
    if ($('.calendar-ms-filter').length > 0){
      init();
    }
  });
}